// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__82hjX","closed":"styles_closed__P5Hp0","closeIconContainer":"styles_closeIconContainer__vvcO0","closeIcon":"styles_closeIcon___2Yd_"};